import {useListView} from '../../core/ListViewProvider'
import {CoordinatorsListToolbar} from './CoordinatorsListToolbar'
import {CoordinatorsListGrouping} from './CoordinatorsListGrouping'
import {CoordinatorsSearchComponent} from './CoordinatorsSearchComponent'
import {TOKENS} from '../../../../../../components/design-system'

type PropTypes = {
  showAddCoordinator?: boolean
}

const CoordinatorsListHeader = ({showAddCoordinator = true}: PropTypes) => {
  const {selected} = useListView()
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: TOKENS.spacing.md,
        padding: '14px 18px',
        borderBottom: `1px solid ${TOKENS.color.border}`,
        background: TOKENS.color.card,
      }}
    >
      <CoordinatorsSearchComponent />
      <div>
        {selected.length > 0 ? <CoordinatorsListGrouping /> : <CoordinatorsListToolbar showAddCoordinator={showAddCoordinator} />}
      </div>
    </div>
  )
}

export {CoordinatorsListHeader}
